import { useId } from 'react';

/** A small vector cumulus silhouette; gradients add depth without bitmap loads. */
export default function CloudShape() {
    const id = useId();
    return <svg viewBox="0 0 240 96" aria-hidden="true" focusable="false" className="cumulus-cloud">
        <defs>
            <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="var(--cloud-highlight, #fffdf7)" />
                <stop offset="0.62" stopColor="var(--cloud-body, #edf1f4)" />
                <stop offset="1" stopColor="var(--cloud-shadow, #b8cad9)" />
            </linearGradient>
        </defs>
        <path d="M28 83C10 83 4 73 9 61C12 52 23 48 35 50C32 28 53 17 73 27C80 5 106 2 123 16C135 9 155 14 161 33C179 21 204 30 207 49C225 48 235 60 231 72C228 84 215 87 195 87H52Z" fill={`url(#${id})`} />
        <path d="M36 52C46 51 57 55 61 61M78 31C75 40 76 45 80 49M162 36C164 46 161 52 156 56M204 52C196 49 187 51 181 56" fill="none" stroke="var(--cloud-highlight, #fffdf7)" strokeWidth="2.5" strokeLinecap="round" opacity="0.35" />
    </svg>;
}
